// Règlements Polaris → copie CIME Plus. Fonctions pures, testées seules.

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  transfer: 'Virement',
  check: 'Chèque',
  other: 'Autre',
};

/** Ce que Polaris renvoie d'une facture (GET /facturation/invoices/:id → invoice). */
export interface PolarInvoicePayments {
  payments: { id: number; paid_on: string; amount_cents: number; method: string; note: string | null }[];
  paid_cents: number;
  remaining_cents: number;
}

export interface PaymentSync {
  payments: { polar_payment_id: string; paid_on: string; amount: number; method: string; note: string | null }[];
  paid: number;
  remaining: number;
}

export function polarInvoiceToPaymentSync(invoice: PolarInvoicePayments): PaymentSync {
  return {
    payments: invoice.payments.map((p) => ({
      polar_payment_id: String(p.id),
      paid_on: p.paid_on.slice(0, 10),
      amount: p.amount_cents / 100,
      method: PAYMENT_METHOD_LABELS[p.method] ?? 'Autre',
      note: p.note?.trim() ? p.note.trim() : null,
    })),
    paid: invoice.paid_cents / 100,
    remaining: invoice.remaining_cents / 100,
  };
}

/** Pièces dont on recopie les règlements : factures numérotées dans Polaris, non annulées. */
export function shouldSyncPayments(doc: {
  doc_type: string;
  status: string;
  polar_invoice_id: string | null;
  number: string | null;
}): boolean {
  return doc.doc_type === 'invoice' && doc.status !== 'void' && !!doc.polar_invoice_id && !!doc.number;
}
